package one.healthium.insights.domain.models


data class MealPlanModel(
    val days: List<MealPlanDayModel>,
    val shoppingList: ShoppingListModel?,
)

data class MealPlanDayModel(
    val totalCalories: Int,
    val breakfast: List<RecipeModel>,
    val lunch: List<RecipeModel>,
    val dinner: List<RecipeModel>,
    val snack: List<RecipeModel>,
    val drink: List<RecipeModel>,
)

data class RecipeModel(
    val id: String,
    val title: String,
    val emoji: String,
    val servingWeightGrams: Int,
    val ingredients: List<IngredientModel>,
    val steps: List<String>,
    val nutritionPer100g: NutritionModel,
) {
    val caloriesPerServing: Int
        get() = (nutritionPer100g.calories * servingWeightGrams / 100).toInt()
}

data class IngredientModel(
    val name: String,
    val emoji: String,
    val amount: Double,
    val unit: String,
)

data class NutritionModel(
    val calories: Double,
    val protein: Double,
    val fat: Double,
    val carbs: Double,
    val fiber: Double = 0.0,
)

fun RecipeModel.toLogMealAction(): ActionModel.LogMeal = ActionModel.LogMeal(
    MealNutritionModel(
        product = title,
        portion = servingWeightGrams.toFloat(),
        calories = nutritionPer100g.calories.toFloat(),
        fat = nutritionPer100g.fat.toFloat(),
        carbs = nutritionPer100g.carbs.toFloat(),
        fiber = nutritionPer100g.fiber.toFloat(),
        protein = nutritionPer100g.protein.toFloat(),
    )
)
